var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 700",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      backgroundColor: "#F7F8F9"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gA",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C8DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#4C8DFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#8A6FDF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8A6FDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gB",
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#41AD88",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#41AD88",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#20C9D5",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#20C9D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gC",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#20C9D5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#20C9D5",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C8DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gD",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8A6FDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#8A6FDF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#20C9D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gE",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C8DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#4C8DFF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C8DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gArc1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C8DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#4C8DFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C8DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gArc2",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#20C9D5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#20C9D5",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#20C9D5",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -100,700 Q 400,100 1100,300",
    stroke: "url(#gArc1)",
    strokeWidth: 120,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1100,0 Q 600,400 -100,250",
    stroke: "url(#gArc2)",
    strokeWidth: 80,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -20,640 C 200,440 440,700 680,500 S 980,200 1020,100",
    stroke: "url(#gA)",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020,160 C 780,360 560,100 300,280 S 40,600 -20,700",
    stroke: "url(#gB)",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -20,360 C 160,160 360,420 560,220 S 820,60 1020,300",
    stroke: "url(#gC)",
    strokeWidth: 0.8,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -20,520 C 240,340 460,560 700,380 S 920,140 1020,40",
    stroke: "url(#gD)",
    strokeWidth: 0.7,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020,480 C 820,300 620,500 380,320 S 120,100 -20,200",
    stroke: "url(#gE)",
    strokeWidth: 0.6,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -20,280 C 180,80 400,320 620,140 S 880,20 1020,180",
    stroke: "#8A6FDF",
    strokeWidth: 0.5,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -20,460 C 260,260 500,480 740,300 S 960,80 1020,220",
    stroke: "#41AD88",
    strokeWidth: 0.5,
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth-background.e6b7c311ab72dcdcf32793bbac6be551.svg";
export { ForwardRef as ReactComponent };